import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { SamplePlan } from './components/SamplePlan';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { shortTestimonials, moreTestimonials, coachProfiles } from './data/testimonials';
// Review sections render only once data/testimonials.ts holds real buyer reviews.
// Swap <SamplePlan /> for <PageCarousel /> once real page images exist in data/volumePages.ts.

export function App() {
  return <div className="min-h-screen w-full bg-cloud text-ink font-sans selection:bg-amber selection:text-ink" data-id="element-0" data-mp="3mjg9hk8s47lo">
      <MetaPixel data-id="element-1" data-mp="3reltgdimfc74" />
      <main data-id="element-2" data-mp="5ot150vj28n">
        <Hero data-id="element-3" data-mp="6hq1ea16ddl" />
        <SocialProofBar data-id="element-4" data-mp="4wupmfw6qeo" />
        <PainGrid data-id="element-5" data-mp="56nfhsbnbo2" />
        <ProductReveal data-id="element-6" data-mp="7sulgbavp5r" />
        <Tomes data-id="element-7" data-mp="2zld1r8m3ndb0" />
        <SamplePlan data-id="element-8" data-mp="2zlv7qwykd5w4" />
        <Bonuses data-id="element-9" data-mp="2zmemk4sx3e5x" />
        <ValueStack data-id="element-10" data-mp="2zmwlj96ys6hj" />
        <Urgency data-id="element-11" data-mp="33mou3lwcycmw" />
        <Pricing data-id="element-12" data-mp="33m5b01uz1i7a" />
        <Testimonials testimonials={shortTestimonials} profiles={coachProfiles} background="white" data-id="element-13" data-mp="33nq5xsl7735o" />
        <Guarantee data-id="element-14" data-mp="38kqce4lym7xb" />
        <Faq data-id="element-15" data-mp="38k6vmr81ppkv" />
        <Testimonials testimonials={moreTestimonials} title="Works alongside your gym’s program" subtitle="Coaches use it to turn the skills they already teach into a full class." background="cream" data-id="element-16" data-mp="38nup5qdhqbzl" />
        <CostOfInaction data-id="element-17" data-mp="stuejtzr4v9j" />
        <Close data-id="element-18" data-mp="stcc2fmhxkt6" />
      </main>
      <Footer data-id="element-19" data-mp="swq9d9gaz3tr" />
    </div>;
}